export const previewBase64Image = async (file) => {
  let src = file.url;
  if (!src) {
    src = await new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file.originFileObj);
      reader.onload = () => resolve(reader.result);
    });
  }
  const image = new Image();
  image.src = src;
  const imgWindow = window.open("about:blank");
  setTimeout(function () {
    imgWindow.document.getElementsByTagName("body")[0].innerHTML =
      image.outerHTML;
  }, 0);
};
